<div
  *ngIf="props.label"
  [ngClass]="{
    'v2-mb-4': props.biggerLabelMargin === true,
    'v2-mb-1': props.biggerLabelMargin !== true,
  }"
  class="d-flex align-items-center"
>
  <typography-v2 look="caption-bold">{{ props.label }}</typography-v2>
  <span *ngIf="props.required" class="text-purple v2-ml-1">*</span>
</div>
<typography-v2 *ngIf="props.description" look="caption" class="text-black-50 d-block v2-mb-2">
  {{ props.description }}
</typography-v2>
<ng-template #fieldComponent></ng-template>

<formly-validation-message
  *ngIf="formControl?.dirty && formControl.errors"
  [field]="field"
></formly-validation-message>
